import { useEffect as e, useRef as t, useState as n } from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { trackEvent as a } from "@cx-web/utils/dataLayer";
var o = {
	carouselContainer: "_carouselContainer_15y0c_1",
	slide: "_slide_15y0c_8",
	bannerImg: "_bannerImg_15y0c_18",
	slideContent: "_slideContent_15y0c_28",
	logo: "_logo_15y0c_32",
	slideLabel: "_slideLabel_15y0c_37",
	slideIndicator: "_slideIndicator_15y0c_43",
	progressContainer: "_progressContainer_15y0c_50",
	progressBar: "_progressBar_15y0c_63",
	progressFill: "_progressFill_15y0c_72",
	fillAnimation: "_fillAnimation_15y0c_1",
	gridContainer: "_gridContainer_15y0c_92",
	gridItem: "_gridItem_15y0c_107"
};
//#endregion
//#region page-template/BannersCarousel/getWebPImageUrlWithWidth.ts
function s(e, t) {
	try {
		let n = new URL(e);
		return n.searchParams.set("fm", "webp"), n.searchParams.set("w", String(t)), n.toString();
	} catch {
		return `${e}${e.includes("?") ? "&" : "?"}fm=webp&w=${t}`;
	}
}
//#endregion
//#region page-template/BannersCarousel/types.ts
var c = { SPLASH_BANNER_CLICK: "splash_banner_click" };
//#endregion
//#region page-template/BannersCarousel/BannersCarouselDesktop.tsx
function l({ banners: l, interval: u = 3e3 }) {
	let d = t(null), [f, p] = n(1), [m, h] = n(!0), [g, _] = n(0), [v, y] = n(null), [b, x] = n(0);
	e(() => {
		if (d.current) {
			let e = () => {
				let e = d.current.clientWidth;
				_(e);
			};
			return e(), window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
		}
	}, []);
	let S = [
		l[l.length - 1],
		...l,
		l[0]
	], C = () => {
		f === S.length - 1 && (h(!1), p(1)), f === 0 && (h(!1), p(l.length));
	};
	e(() => {
		if (!m) {
			let e = setTimeout(() => h(!0), 50);
			return () => clearTimeout(e);
		}
	}, [m]);
	let w = (e) => y(e.clientX), T = (e) => {
		v !== null && x(e.clientX - v);
	}, E = () => {
		if (v !== null) {
			let e = g * .2;
			b > e ? p((e) => e - 1) : b < -e && p((e) => e + 1), y(null), x(0);
		}
	}, D = (e) => y(e.touches[0].clientX), O = (e) => {
		v !== null && x(e.touches[0].clientX - v);
	}, k = () => {
		if (v !== null) {
			let e = g * .2;
			b > e ? p((e) => e - 1) : b < -e && p((e) => e + 1), y(null), x(0);
		}
	}, A = v === null && m ? "transform 0.5s ease-in-out" : "none", j = {
		display: "flex",
		width: `${S.length * 100}%`,
		transform: `translateX(-${f * 100 / S.length}%)`,
		transition: A
	}, M = f - 1;
	M < 0 && (M = l.length - 1), M >= l.length && (M = 0);
	let N = f;
	return /* @__PURE__ */ i("div", {
		className: o.carouselContainer,
		"data-testid": "banners-carousel-desktop",
		onMouseDown: w,
		onMouseLeave: E,
		onMouseMove: T,
		onMouseUp: E,
		onTouchEnd: k,
		onTouchMove: O,
		onTouchStart: D,
		ref: d,
		children: [/* @__PURE__ */ r("ul", {
			"data-testid": "carousel-list",
			onTransitionEnd: C,
			style: j,
			children: S.map((e, t) => /* @__PURE__ */ r("li", {
				style: {
					width: `${100 / S.length}%`,
					listStyle: "none",
					flexShrink: 0,
					aspectRatio: "3.45 / 1"
				},
				children: /* @__PURE__ */ r("a", {
					href: e.ctaUrl,
					onClick: () => {
						a(c.SPLASH_BANNER_CLICK, {
							eventAction: c.SPLASH_BANNER_CLICK,
							label: e.style,
							bannerName: e.bannerName,
							bannerType: e.bannerType,
							bookieCode: e.bookieCode,
							url: e.ctaUrl,
							position: (t - 1 + l.length) % l.length
						});
					},
					rel: "noreferrer",
					target: "_blank",
					children: /* @__PURE__ */ r("div", {
						"aria-label": e.imageLarge.alt,
						className: o.slide,
						children: /* @__PURE__ */ r("img", {
							alt: e.imageLarge.alt,
							className: o.bannerImg,
							draggable: !1,
							fetchPriority: t === 1 ? "high" : "low",
							src: s(e.imageLarge.url, 1100)
						})
					})
				})
			}, t))
		}), /* @__PURE__ */ i("div", {
			className: o.progressContainer,
			children: [l.map((e, t) => /* @__PURE__ */ r("div", {
				className: o.progressBar,
				onClick: () => p(t + 1),
				children: M === t && /* @__PURE__ */ r("div", {
					className: o.progressFill,
					onAnimationEnd: () => p((e) => e + 1),
					style: {
						animationDuration: `${u}ms`,
						animationPlayState: v === null ? "running" : "paused"
					}
				}, N)
			}, t)), /* @__PURE__ */ i("div", {
				className: o.slideIndicator,
				"data-testid": "slide-indicator",
				children: [
					M + 1,
					" / ",
					l.length
				]
			})]
		})]
	});
}
//#endregion
//#region page-template/BannersCarousel/BannersCarouselGrid.tsx
function u({ banners: e, isMobile: t }) {
	let n = t ? 320 : 800;
	return /* @__PURE__ */ r("ul", {
		className: o.gridContainer,
		children: e.map((e, t) => /* @__PURE__ */ r("li", {
			className: o.gridItem,
			children: /* @__PURE__ */ r("a", {
				href: e.ctaUrl,
				onClick: () => {
					a(c.SPLASH_BANNER_CLICK, {
						eventAction: c.SPLASH_BANNER_CLICK,
						label: e.style,
						bannerName: e.bannerName,
						bannerType: e.bannerType,
						bookieCode: e.bookieCode,
						url: e.ctaUrl,
						position: t
					});
				},
				rel: "noreferrer",
				target: "_blank",
				children: /* @__PURE__ */ r("div", {
					"aria-label": e.imageSmall.alt,
					className: o.slide,
					children: /* @__PURE__ */ r("img", {
						alt: e.imageSmall.alt,
						className: o.bannerImg,
						draggable: !1,
						fetchPriority: t === 0 ? "high" : "low",
						src: s(e.imageSmall.url, n)
					})
				})
			})
		}, t))
	});
}
//#endregion
//#region page-template/BannersCarousel/BannersCarousel.tsx
function d({ banners: e, interval: t = 4e3, isDesktop: n, isMobile: i }) {
	return !e || e.length === 0 ? null : n ? /* @__PURE__ */ r(l, {
		banners: e,
		interval: t
	}) : /* @__PURE__ */ r(u, {
		banners: e,
		isMobile: i
	});
}
//#endregion
export { l as BannersCarouselDesktop, u as BannersCarouselGrid, d as default, c as events, s as getWebPImageUrlWithWidth };
